import { last } from 'lodash';

export function getView(url) {
  const view = last(url.replace(/\?.*$/, '').split('/'));
  if (url.includes('/controlpanel/')) {
    return 'controlpanel'
  }
  if (
    [
      'add',
      'layout',
      'contents',
      'edit',
      'delete',
      'diff',
      'history',
      'sharing',
      'controlpanel',
      'search',
      'sitemap',
      'contact-form',
    ].indexOf(view) === -1
  ) {
    return 'view';
  }
  return view === 'layout' ? 'edit' : view;
}